module.exports = __webpack_public_path__ + "static/media/delete.c12f6c6a.svg";